import { onMounted, onUnmounted } from 'vue';
import api from '@/utils/api';

export function useSessionKeepAlive() {
  let intervalId = null;
  let isActive = false;

  const pingServer = async () => {
    try {
      // Ping the /me endpoint to keep session alive and refresh CSRF token
      await api.get('/api/me');
      console.log('[Session Keep-Alive] Session refreshed successfully');
    } catch (error) {
      console.error('[Session Keep-Alive] Failed to refresh session:', error);
      
      // If we get 401 or 419 (CSRF token mismatch), redirect to login
      if (error.response && (error.response.status === 401 || error.response.status === 419)) {
        console.warn('[Session Keep-Alive] Session expired, redirecting to login...');
        window.location.href = '/login';
      }
    }
  };

  const startKeepAlive = () => {
    if (isActive) return;
    
    isActive = true;
    // Ping immediately on start
    pingServer();
    
    // Then ping every 5 minutes (300000 ms)
    intervalId = setInterval(pingServer, 5 * 60 * 1000);
    console.log('[Session Keep-Alive] Started (pinging every 5 minutes)');
  };

  const stopKeepAlive = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
      isActive = false;
      console.log('[Session Keep-Alive] Stopped');
    }
  };

  // Auto-start on mount, auto-stop on unmount
  onMounted(() => {
    startKeepAlive();
  });

  onUnmounted(() => {
    stopKeepAlive();
  });

  return {
    startKeepAlive,
    stopKeepAlive,
    pingServer
  };
}
